import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { Input, Label, Button, Row, Col } from "reactstrap";
import ValidationMsgComponent from "../ValidationMsgComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";


interface ControlledTextFieldProps {
  label: string;
  inputName: string;
  inputType: string;
  placeholder?: string;
  invalid?: boolean;
  control: any;
  rules?: object;
  errors?: object;
  register?: any;
  isRequired?: boolean;
  hasSideLabel?: boolean;
  sideLabel?: string;
  isDisabled?: boolean;
  defaultValue?: string;
  className?: string;
}

type MyInputType =
  | "text"
  | "email"
  | "password"
  | "number"
  | "tel"
  | "url"
  | "search"
  | "date"
  | "datetime-local"
  | "time"
  | "week"
  | "month"
  | "color";

const ControlledTextFieldTime: React.FC<ControlledTextFieldProps> = ({
  label,
  inputName,
  inputType,
  placeholder,
  invalid,
  control,
  rules,
  errors,
  isRequired,
  hasSideLabel,
  sideLabel,
  isDisabled,
  defaultValue,
  className,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="my-1">
      <Row>
        <Col lg="4">
          <Label
            className={`${label === "" ? "pt-1" : ""} form-label`}
            htmlFor={inputName}
          >
            {isRequired ? `${label} ` : label}
          </Label>
        </Col>
        <Col lg="8">
          <div className="d-flex flex-row align-items-center">
            <Controller
              name={inputName}
              control={control}
              defaultValue={defaultValue}
              rules={rules}
              render={({ field }) => (
                <>
                  <Input
                    id={inputName}
                    type={showPassword ? "text" : (inputType as MyInputType)}
                    placeholder={placeholder}
                    invalid={invalid}
                    disabled={isDisabled}
                    {...field}
                    value={field.value || defaultValue}
                    className={className}
                  />
                  {inputType === "password" && (
                    <Button onClick={togglePasswordVisibility} className="ms-2">
                      {showPassword ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                    </Button>
                  )}
                </>
              )}
            />
            {hasSideLabel && <span className="ps-1 me-1">{sideLabel}</span>}
          </div>
        </Col>
      </Row>
      {invalid && (
        <ValidationMsgComponent
          inputName={inputName}
          invalid={invalid}
          errors={errors}
          rules={rules}
        />
      )}
    </div>
  );
};

export default ControlledTextFieldTime;
